export enum PaymentSystemsEnum {
  Safaricom = 'safaricom',
  Eurocom = 'eurocom',
  PayPal = 'paypal'
}
